export default function Reducer(state, action) {
  switch (action.type) {
    case 'LOAD':
      return {
        ...state,
        user: action.user,
      };
    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}
